export default "__VITE_ASSET__BeSWdq7T__"